import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import Configs from "../../config"
import moment from "moment"
import React, { useEffect, useState } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaDownload,
  FaPen,
  FaTrash,
  FaPlus,
  FaEye,
} from "react-icons/fa6"
import Select from "react-select"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
} from "utils/Common_api_functions"
import { customStyles } from "utils/SelectStyles"

const activities = [
  { name: "Run" },
  { name: "Bike" },
  { name: "Swim" },
  { name: "Brick" },
  { name: "Crosstrain" },
  { name: "Day off" },
  { name: "Mtn Bike" },
  { name: "Strength" },
  { name: "Custom" },
  { name: "XC-Ski" },
  { name: "Walk" },
  { name: "Other" },
]

const activityOptions = [
  { value: "", label: "All Activities" },
  ...activities.map(act => ({ value: act.name, label: act.name })),
]

const SeasonIndex = () => {
  const [loading, setLoading] = useState(false)
  const [searchString, setSearchString] = useState("")

  const [seasons, setSeasons] = useState([])
  const [data, setData] = useState([])
  const [selectedSeason, setSelectedSeason] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [selectedActivity, setSelectedActivity] = useState("")
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)

  useEffect(() => {
    getSeasonData()
  }, [])

  async function getSeasonData() {
    const APIData = await fetchData(setLoading, "season")

    if (APIData.success) {
      setSeasons(APIData?.seasons)
      setData(APIData?.seasons)
    }
  }

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(item =>
        item.seasonName.toLowerCase().includes(searchString.toLowerCase())
      )
      setSeasons(filteredData)
      setPage(1)
    } else {
      setSeasons(data)
    }
  }, [searchString, data])

  const [newSeason, setNewSeason] = useState({
    seasonName: "",
    startDate: "",
    endDate: "",
  })

  const totalPages = Math.ceil(seasons.length / itemsPerPage)
  const finalData = seasons.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const getStatus = (start, end) => {
    const today = moment()
    if (today.isBefore(moment(start))) return "Upcoming"
    if (today.isAfter(moment(end))) return "Completed"
    return "Ongoing"
  }

  const handleExport = league => {
    // Construct the full API URL
    const url = `${Configs.baseURL}season/export/${league._id}`

    // Open in a new tab
    window.open(url, "_blank")
  }

  const handleEdit = season => {
    setSelectedSeason(season)
    setIsModalOpen(true)
  }

  const handleDelete = async seasonId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the Season.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setLoading, "season", seasonId)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "Season Deleted Successfully",
            icon: "success",
          })
          getSeasonData()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIData?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const handleAddSeason = async e => {
    e.preventDefault()
    const season = {
      seasonName: newSeason.seasonName,
      startDate: newSeason.startDate,
      endDate: newSeason.endDate,
    }

    const APIData = await FetchPostData(setLoading, "/season", season)

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Season Added Successfully",
        icon: "success",
      })
      setNewSeason({ seasonName: "", startDate: "", endDate: "" })
      setIsAddModalOpen(false)
      getSeasonData()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Season Management" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Seasons</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Seasons"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    {/* <div style={{ minWidth: "200px" }}>
                      <Select
                        options={activityOptions}
                        value={activityOptions.find(
                          opt => opt.value === selectedActivity
                        )}
                        onChange={opt => setSelectedActivity(opt?.value || "")}
                        placeholder="Filter by Activity"
                        isClearable
                        styles={customStyles}
                      />
                    </div> */}

                    <Button
                      className="d-flex btn btn-add align-items-center"
                      onClick={() => setIsAddModalOpen(true)}
                    >
                      <FaPlus className="me-1" size={14} /> Add Season
                    </Button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Season Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((season, index) => {
                        const status = getStatus(
                          season.startDate,
                          season.endDate
                        )
                        return (
                          <tr key={season.id}>
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td>{season?.seasonName}</td>
                            <td>
                              {moment(season?.startDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {moment(season?.endDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {status === "Upcoming" && (
                                <span className="badge bg-info p-2 fs-6">
                                  {status}
                                </span>
                              )}
                              {status === "Ongoing" && (
                                <span className="badge bg-success p-2 fs-6">
                                  {status}
                                </span>
                              )}
                              {status === "Completed" && (
                                <span className="badge bg-secondary p-2 fs-6">
                                  {status}
                                </span>
                              )}
                            </td>
                            <td>
                              {/* <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => handleExport(season)}
                              >
                                <FaDownload size={12} />
                              </button> */}
                              <button
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => handleEdit(season)}
                              >
                                <FaEye size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDelete(season._id)}
                              >
                                <FaTrash size={12} />
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={6} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {seasons.length} Seasons.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Details Modal */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
          Season Details
        </ModalHeader>
        <ModalBody>
          {selectedSeason ? (
            <Table bordered>
              <tbody>
                <tr>
                  <th>Season ID</th>
                  <td>{selectedSeason._id}</td>
                </tr>
                <tr>
                  <th>Season Name</th>
                  <td>{selectedSeason.seasonName}</td>
                </tr>
                <tr>
                  <th>Start Date</th>
                  <td>
                    {moment(selectedSeason.startDate).format("DD-MM-YYYY")}
                  </td>
                </tr>
                <tr>
                  <th>End Date</th>
                  <td>{moment(selectedSeason.endDate).format("DD-MM-YYYY")}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    {getStatus(
                      selectedSeason.startDate,
                      selectedSeason.endDate
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <p>No season selected.</p>
          )}
        </ModalBody>
      </Modal>

      {/* Add Season Modal */}
      <Modal
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen(!isAddModalOpen)}
        centered
      >
        <ModalHeader toggle={() => setIsAddModalOpen(!isAddModalOpen)}>
          Add Season
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleAddSeason}>
            <FormGroup>
              <Label>
                Season Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                value={newSeason.seasonName}
                onChange={e =>
                  setNewSeason({ ...newSeason, seasonName: e.target.value })
                }
                required
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Start Date <span className="text-danger">*</span>
              </Label>
              <Input
                type="date"
                min={new Date().toISOString().split("T")[0]}
                value={newSeason.startDate}
                onChange={e =>
                  setNewSeason({ ...newSeason, startDate: e.target.value })
                }
                required
              />
            </FormGroup>
            <FormGroup>
              <Label>
                End Date <span className="text-danger">*</span>
              </Label>
              <Input
                type="date"
                min={
                  newSeason.startDate || new Date().toISOString().split("T")[0]
                }
                value={newSeason.endDate}
                onChange={e =>
                  setNewSeason({ ...newSeason, endDate: e.target.value })
                }
                required
              />
            </FormGroup>
            <div className="text-end">
              <Button color="primary" type="submit">
                Add Season
              </Button>
              <Button
                color="danger"
                className="ms-2"
                onClick={() => setIsAddModalOpen(!isAddModalOpen)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default SeasonIndex
